import { Appearance } from "@stripe/stripe-js";

// this is the default stripe theme that overrides all stripe elements used
export const appearance: Appearance = {
  variables: {
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    fontSizeSm: "0.875rem",
  },
};
